import { AlgoComponent } from "./AlgoComponent";
import { mainAlgoCreationPanels } from "./AlogPanels";
import { DroppableComponent } from "./DroppableComponent";

export const Criterion = ({
    criterionData, setCriterionData, criterionType, setDNDRequest, dndRequest, setAlgoData, operatorTypes
}) => {
    return (
        <div className={`droppable-panel h-full bg-[#F2F2F2] flex flex-col flex-1`}>
            <div className="flex flex-col h-full">
                <div className="flex flex-col h-[100px] w-full border-b border-[#909090] text-[#001639] text-[15px] leading-7  pl-[30px] justify-center">{criterionType} CRITERION</div>
                    <DroppableComponent accepts={"mainPanel"} callback={(res) => {
                        setDNDRequest((request) => [...request, {
                            type: criterionType,
                            operationType: '',
                            leftLogic: {
                                type: '',//component or number
                                value: 0, // This will be addressed if above type is number
                                componentName: '', // RSI, EMA etc can be the value
                                timeRange: 0, 
                                status: '' // Close or Open can be the value
                            },
                            rightLogic: {
                                type: '',//component or number
                                value: 0, // This will be addressed if above type is number
                                componentName: '', // RSI, EMA etc can be the value
                                timeRange: 0, 
                                status: '' // Close or Open can be the value
                            },
                            shares: 0
                        }])
                    }} classes="overflow-auto flex flex-col items-center">
                        {dndRequest.map((picture, index) => {
                            if(picture?.type === criterionType)
                                return (<div>
                                            <p className="text-sm font-bold py-2.5">{picture.stock.name}</p>
                                            <AlgoComponent algoType={criterionType} algoIndex={index} dndRequest={dndRequest} setDNDRequest={setDNDRequest} setAlgoData={setAlgoData} operatorTypes={operatorTypes}/>
                                        </div>)
                        })}
                    </DroppableComponent>
            </div>
        </div>
    );
}